import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
  Inject,
  OnDestroy,
} from "@angular/core";
import { FormGroup } from "@angular/forms";
// RxJS

import { NoteModel } from "./note.model";
import { SharedService } from "../shared.service";
import { MatDialog } from "@angular/material/dialog";
import { NoteAndFieldsDialogComponent } from "./note-and-fields-dialog.component";
import { TranslateService } from "@ngx-translate/core";
import { LayoutUtilsService, MessageType, API } from "../../../core/_base/crud";
import { DOCUMENT } from "@angular/common";
import { currentUser } from "../../../core/auth";
import { select, Store } from "@ngrx/store";
import { AppState } from "../../../core/reducers";
import { NoteCategories } from "../enums/notes.enum";
import { NotePermissions } from "../enums/permission/notePermissions";
import { Subscription } from "rxjs";

@Component({
  selector: "cc-notes",
  templateUrl: "./notes.component.html",
  styleUrls: ["./notes.component.scss"],
})
export class NotesComponent implements OnInit, OnChanges, OnDestroy {
  public product: NoteModel;
  public productForm: FormGroup;
  public notes: Array<NoteModel>;
  public customers: Array<any>;
  permissions: any = [];
  @Input() entityCustomers;
  @Input() entity_id;
  @Input() entity_type;
  @Input() user;
  idNote: any;
  updateNote: boolean = false;
  example: string;
  createPdfNote: boolean = false;
  subscriptions: Subscription[] = [];

  constructor(
    private productsService: SharedService,
    public dialog: MatDialog,
    private ref: ChangeDetectorRef,
    private translate: TranslateService,
    private layoutUtilsService: LayoutUtilsService,
    private store: Store<AppState>,
    @Inject(DOCUMENT) private document
  ) {
    this.notes = new Array();
    this.customers = new Array();
  }

  ngOnInit(): void {
    this.getNotes();
    this.loadCustomers();

    if (!this.user) {
      this.store.pipe(select(currentUser)).subscribe((res: { permission_list: [] }) => {
        this.user = res;
        this.permissions = this.user?.permissions_list;
      });
    } else {
      this.permissions = this.user?.permissions_list;
    }

    this.updateNote = this.permissions?.some((permission) => permission.name === "update_notes") ?? false;
    this.createPdfNote =
      this.permissions?.some((permission) => permission.name === NotePermissions.CREATE_PDF_NOTES) ?? false;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.loadCustomers();
  }

  getNotes() {
    this.notes = [];
    this.productsService.getContractOrCustomerNotes(this.entity_id, this.entity_type).subscribe((res) => {
      res.data.forEach((note) => {
        this.notes.push(new NoteModel().setAttributes(note));
        this.ref.detectChanges();
      });
    });
  }

  public loadCustomers() {
    this.customers = [];
    switch (this.entity_type) {
      case "customer":
        this.customers = [this.entityCustomers];
        break;

      default:
        this.entityCustomers.forEach((customer) => {
          if (customer.is_active || this.entity_type === "offer") this.customers.push(customer.customer);
        });
        break;
    }
  }

  editNote(note: NoteModel) {
    const dialogRef = this.dialog.open(NoteAndFieldsDialogComponent, {
      data: {
        entity_type: this.entity_type,
        entity: note ? note : new NoteModel().clear(),
        entity_id: this.entity_id,
        customers: this.customers,
        permissions: this.permissions,
      },
      width: "600px",
      maxHeight: "70vh",
    });
    const subscription = dialogRef.afterClosed().subscribe((res) => {
      res = res?.data;
      if (res && !note) {
        this.getNotes();
        this.layoutUtilsService.showActionNotification(
          this.translate.instant("NOTES.ADD.CREATE_SUCCESS"),
          MessageType.Create
        );
        this.ref.detectChanges();
      } else if (res) {
        this.getNotes();
        this.layoutUtilsService.showActionNotification(
          this.translate.instant("NOTES.ADD.UPDATE_SUCCESS"),
          MessageType.Update
        );
        this.ref.detectChanges();
      }
    });
    this.subscriptions.push(subscription);
  }

  deleteNote(deletedNote: { id: number }) {
    this.productsService.deleteNote(this.entity_type, deletedNote).subscribe(
      (res: any) => {
        this.notes.splice(
          this.notes.findIndex((note) => note.id == deletedNote.id),
          1
        );
        // we Need change the message response later
        this.layoutUtilsService.showActionNotification("Item has been deleted successfully", MessageType?.Delete);
        this.ref.detectChanges();
      },
      (err) => {
        this.layoutUtilsService.showActionNotification(
          "Item has not been deleted successfully Try again later!",
          MessageType?.Delete
        );
      }
    );
  }

  deleteProduct(note) {
    const _title: string = this.translate.instant("GENERAL.DELETE_NOTE");
    const _description: string = this.translate.instant("GENERAL.DELETE_NOTE_MSG");
    const _waitDesciption: string = this.translate.instant("GENERAL.DELETE_WAIT_MSG");
    const dialogRef = this.layoutUtilsService.deleteElement(_title, _description, _waitDesciption);
    const subscription = dialogRef.beforeClosed().subscribe((res) => {
      if (!res) {
        return;
      } else {
        this.deleteNote(note);
      }
    });
    this.subscriptions.push(subscription);
  }

  showNotesActions(note) {
    const updatePdfNotePermission =
      this.updateNote && (note?.category?.code !== NoteCategories.PDF_NOTE || this.createPdfNote);
    const deletePdfNotePermission =
      note?.created_by_id === this.user?.id && (note?.category?.code !== NoteCategories.PDF_NOTE || this.createPdfNote);
    return updatePdfNotePermission || deletePdfNotePermission || this.user?.role?.name === "super_admin";
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
